import React, { useEffect, useState } from 'react';
import { DirectPDFGenerator } from '../../services/directPdfGenerator';
import CalendarGrid from '../../components/CalendarGrid/CalendarGrid';
import styles from './PDF.module.css';

const PDF: React.FC = () => {
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const generatePDF = async () => {
      setIsGenerating(true);
      setError(null);

      try {
        console.log('Début de la génération PDF...');
        
        // Attendre que le DOM soit complètement chargé
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        // Vérifier que le calendrier est présent
        const grid = document.getElementById("calendar-grid-table");
        if (!grid) {
          throw new Error("Calendrier non trouvé dans le DOM");
        }
        
        console.log('Calendrier trouvé, génération du PDF...');
        
        // Générer le PDF
        await DirectPDFGenerator.generateDirectPDF();
        
        console.log('PDF généré avec succès, redirection...');
        
        // Attendre un peu avant la redirection pour que le téléchargement commence
        await new Promise(resolve => setTimeout(resolve, 1000));
        
        // Rediriger vers la page principale après génération
        window.location.href = '/';
      } catch (err) {
        console.error('Erreur complète:', err);
        setError(err instanceof Error ? err.message : 'Erreur lors de la génération du PDF');
      } finally {
        setIsGenerating(false);
      }
    };

    generatePDF();
  }, []);

  return (
    <div className={styles.pdfContainer}>
      {/* Header */}
      <header className={styles.pdfHeader}>
        <div>
          <img 
            src="/logo-union-vert-white.png" 
            alt="Union Vovinam" 
            className={`${styles.pdfLogo} ${styles.pdfLogoLeft}`}
          />
        </div>
        <div className={styles.pdfTitleContainer}>
          <h1 className={styles.pdfMainTitle}>
            Calendrier des événements Union Vovinam Viet Vo Dao France
          </h1>
          <h2 className={styles.pdfSubtitle}>
            Saison sportive 2025-2026
          </h2>
        </div>
        <div>
          <img 
            src="/logo-vovinam.svg" 
            alt="Vovinam" 
            className={`${styles.pdfLogo} ${styles.pdfLogoRight}`}
          />
        </div>
      </header>

      {/* Contenu principal */}
      <div className={styles.pdfContent}>
        {isGenerating && (
          <div style={{ textAlign: 'center' }}>
            <div className={styles.pdfLoadingSpinner} />
            <h2 className={styles.pdfLoadingTitle}>
              Génération du PDF en cours...
            </h2>
            <p className={styles.pdfLoadingText}>
              Veuillez patienter, le téléchargement va commencer automatiquement.
            </p>
          </div>
        )}

        {error && (
          <div className={styles.pdfErrorContainer}>
            <h2 className={styles.pdfErrorTitle}>Erreur lors de la génération</h2>
            <p className={styles.pdfErrorText}>{error}</p>
            <button 
              onClick={() => window.location.href = '/'}
              className={styles.pdfBackButton}
            >
              Retourner au calendrier
            </button>
          </div>
        )}
      </div>

      {/* Calendrier caché pour la génération PDF */}
      <div className={styles.pdfHiddenCalendar}>
        <CalendarGrid />
      </div>
    </div>
  );
};

export default PDF;
